var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AxButton',{staticClass:"saml-login-btn",attrs:{"block":"","type":"submit","large":"","color":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.handleSamlLogin.apply(null, arguments)}}},[_vm._v(" Sign in using Single Sign-On ")])
}
var staticRenderFns = []

export { render, staticRenderFns }